import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useTipoCota = () => {
  const [tipoCota, setTipoCota] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchTipoCota = async () => {
      try {
        const response = await httpClient.get(`/api/proaqitem/tipocota`);

        const options = response.data.map(
          (tipoCota: { value: number; label: string }) => ({
            value: tipoCota.value.toString(),
            label: tipoCota.label,
          }),
        );
        setTipoCota(options);
      } catch (error) {
        console.error(
          'Erro ao buscar Tipo de Cota do Item do Processo Aquisitivo',
          error,
        );
      }
    };

    fetchTipoCota();
  }, []);

  return tipoCota;
};
